// src/components/renderers/MCQRenderer.js
import React from 'react';

const MCQRenderer = ({ 
  question, 
  userAnswer, 
  onAnswerChange, 
  showFeedback,
  showCorrectAnswers 
}) => {
  const content = question.content || {};
  const options = content.options || [];

  const handleSelect = (optionId) => {
    if (!showFeedback && onAnswerChange) {
      onAnswerChange(optionId);
    }
  };

  const getOptionClass = (option) => {
    const classes = ['mcq-option'];
    
    if (userAnswer === option.id) {
      classes.push('selected');
    }

    if (showFeedback || showCorrectAnswers) {
      if (option.isCorrect) {
        classes.push('correct');
      } else if (userAnswer === option.id && !option.isCorrect) {
        classes.push('incorrect');
      }
    }

    return classes.join(' ');
  };

  return (
    <div className="question-renderer mcq-renderer">
      <div className="question-stem" dangerouslySetInnerHTML={{ __html: content.stem || '' }} />

      <div className="options-container">
        {options.map((option, index) => (
          <div
            key={option.id}
            className={getOptionClass(option)}
            onClick={() => handleSelect(option.id)}
          >
            <div className="option-marker">{String.fromCharCode(65 + index)}</div>
            <div className="option-text">{option.text}</div>
            {(showFeedback || showCorrectAnswers) && option.isCorrect && (
              <div className="correct-indicator">✓</div>
            )}
          </div>
        ))}
      </div>

      {showFeedback && (
        <div className="feedback-section">
          {content.generalFeedback && (
            <div className="general-feedback">
              <strong>Feedback:</strong> {content.generalFeedback}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MCQRenderer;